import {ALIS, SATIS} from "./constants";

export function getPrice(name) {
   /* global prices */
   let temp = (prices || []).find((price) => {
      return price[0] === name
   });

   if (temp) {
      return {alis: parseFloat(temp[1]).toFixed(2), satis: parseFloat(temp[3]).toFixed(2)}
   } else {
      return {alis: 0, satis: 0}
   }
}


export function calculateItem(hasAltin, data, type, name) {
   if(data[name][type].devre_disi){
      let otherType = type === ALIS ? SATIS : ALIS;
      return (parseFloat(calculateItem(hasAltin,data,otherType,name)) + parseFloat(data[name][type].diger_hesaplanana_ekle)).toFixed(2)
   }
   let sonuc = parseFloat(hasAltin[type]) + parseFloat(data.has_altin[type + '_ekleme'] || 0);
   sonuc = sonuc * (data[name][type].katsayi || 1);

   if (data[name][type].ekleme_aktif) {
      if (data[name][type].kusurat_aktif) {
         if ((sonuc - Math.floor(sonuc)) < data[name][type].kusurat) {
            sonuc += parseFloat(data[name][type].ekleme || 0);
         }
      } else {
         sonuc += parseFloat(data[name][type].ekleme || 0);
      }
   }

   if (data[name][type].tam_yuvarla) {
      if (data[name][type].asagi_yuvarla) {
         sonuc = Math.floor(sonuc);
      } else if (data[name][type].yukari_yuvarla) {
         sonuc = Math.ceil(sonuc);
      }
   } else {
      if (data[name][type].asagi_yuvarla) {
         sonuc = Math.floor(sonuc) + (Math.round((sonuc - Math.floor(sonuc))) ? 0.5 : 0.0);
      } else if (data[name][type].yukari_yuvarla) {
         sonuc = Math.floor(sonuc) + (Math.round((sonuc - Math.floor(sonuc))) ? 1 : 0.5);
      }
   }

   sonuc = sonuc * (data[name][type].sonucu_carp || 1)

   if(data[name][type].sonuc_x_in_kati){
      if (data[name][type].asagi_yuvarla) {
         sonuc = sonuc - (sonuc % parseFloat(data[name][type].sonuc_x_in_kati))
      } else if (data[name][type].yukari_yuvarla) {
         sonuc = sonuc - (sonuc % parseFloat(data[name][type].sonuc_x_in_kati)) + parseFloat(data[name][type].sonuc_x_in_kati)
      }
   }

   // ata altın 5in katı sonuç verecek
   /*if (name === 'cumhuriyet_ata') {
      if (data[type].asagi_yuvarla) {
         sonuc = sonuc - (sonuc % 5)
      } else if (data[type].yukari_yuvarla) {
         sonuc = sonuc - (sonuc % 5) + 5
      }
   }*/

   return sonuc.toFixed(2);
}


export function calculateCurrency(currency, data, type) {
   //const {name,type, price} = this.props;
   let sonuc = parseFloat(currency[type]) + parseFloat(data[type].ekleme || 0);

   if (data[type].tam_yuvarla) {
      if (data[type].asagi_yuvarla) {
         sonuc = Math.floor(sonuc);
      } else if (data[type].yukari_yuvarla) {
         sonuc = Math.ceil(sonuc);
      }
   } else {
      if (data[type].asagi_yuvarla) {
         sonuc = Math.floor(sonuc) + (Math.round((sonuc - Math.floor(sonuc))) ? 0.5 : 0.0);
      }

      if (data[type].yukari_yuvarla) {
         sonuc = Math.floor(sonuc) + (Math.round((sonuc - Math.floor(sonuc))) ? 1 : 0.5);
      }
   }

   return sonuc.toFixed(2);
}


// WEBPACK FOOTER //
// ./src/commons.js